import {apiMemberserviceEndpoint} from '@/config/config.js';
import { createApiClient } from "@/services/baseservice.js"

const apiScope = 'api://memberservice-api/Member.Read'

const baseservice = createApiClient(apiScope, apiMemberserviceEndpoint)

export default {
    async getAll() {
        return await baseservice.get('/membergroups',
            { baseURL: apiMemberserviceEndpoint });
    },
    async create(memberGroup) {
        return await baseservice.post('/membergroups', memberGroup,
            { baseURL: apiMemberserviceEndpoint });
    },
    async createMember(memberGroupId, member) {
        return await baseservice.post('/membergroups/' + memberGroupId, member,
            { baseURL: apiMemberserviceEndpoint});
    },
    async get(memberGroupId) {
        return await baseservice.get('/membergroups/' + memberGroupId,
            { baseURL: apiMemberserviceEndpoint })
    },
    async update(memberGroupId, memberGroup) {
        return await baseservice.put('/membergroups/' + memberGroupId, memberGroup,
            { baseURL: apiMemberserviceEndpoint }
        )
    },
    async updateStatus(url) {
        return await baseservice.put(url,
            { baseURL: apiMemberserviceEndpoint })
    },
    async activate(memberGroupId) {
        return await baseservice.put('/membergroups/' + memberGroupId + '/activate',
            { baseURL: apiMemberserviceEndpoint }
        )
    },
    async split(memberGroupId, input) {
        return await baseservice.put('/membergroups/' + memberGroupId + '/split', input,
            { baseURL: apiMemberserviceEndpoint }
        )
    },
};

